import {
  IssueSeverityEnum,
  IssueWorkflowExecutionTypeValues,
} from '@issuemanager/constants';
import { z } from 'zod';
import { actionTemplateSchema } from '../action-template';
import { GovmapGroupsSchemaType, govmapGroupsSchema } from '../govmap-group';

export const issueTemplateSchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  isAutomatic: z.boolean(),
  executionType: z.enum(IssueWorkflowExecutionTypeValues),
  issueTypeConfigId: z.string(),
  dueDate: z.number().int().gte(0).nullable(),
  severity: z.nativeEnum(IssueSeverityEnum).nullable(),
  ownerId: z.string().nullable(),
  approverId: z.string().nullable(),
  actions: z.array(actionTemplateSchema),
  addedBy: z.string().nullable(),
});

export const issueTemplateDatabaseBasicSchema = z.object({
  id: z.string(),
  slug: z.string(),
  title: z.string(),
  is_automatic: z.boolean(),
  execution_type: z.enum(IssueWorkflowExecutionTypeValues),
  issue_type_config_id: z.string(),
  due_date: z.number().int().gte(0).nullable(),
  severity: z.nativeEnum(IssueSeverityEnum).nullable(),
  owner_id: z.string().nullable(),
  approver_id: z.string().nullable(),
  added_by: z.string().nullable(),
});

export const issueTemplateDatabaseSchema =
  issueTemplateDatabaseBasicSchema.transform((data) => ({
    id: data.id,
    slug: data.slug,
    title: data.title,
    isAutomatic: data.is_automatic,
    executionType: data.execution_type,
    issueTypeConfigId: data.issue_type_config_id,
    dueDate: data.due_date,
    severity: data.severity,
    ownerId: data.owner_id,
    approverId: data.approver_id,
    addedBy: data.added_by,
  }));
export const issueTemplateWithGovMapsDatabaseSchema =
  issueTemplateDatabaseBasicSchema
    .extend({
      govmapGroups: govmapGroupsSchema.nullable(),
      issueTypeId: z.string(),
      issueSubtypeId: z.string().nullable(),
    })
    .transform((data) => ({
      id: data.id,
      slug: data.slug,
      title: data.title,
      isAutomatic: data.is_automatic,
      executionType: data.execution_type,
      issueTypeConfigId: data.issue_type_config_id,
      dueDate: data.due_date,
      severity: data.severity,
      ownerId: data.owner_id,
      approverId: data.approver_id,
      addedBy: data.added_by,
      govmapGroups: data.govmapGroups,
      issueTypeId: data.issueTypeId,
      issueSubtypeId: data.issueSubtypeId,
    }));
export type IssueTemplate = z.infer<typeof issueTemplateSchema>;

export type IssueTemplateEntity = z.infer<typeof issueTemplateDatabaseSchema>;
export type IssueTemplateData = Omit<
  IssueTemplate,
  'slug' | 'issueTypeConfigId'
>;
export type IssueTemplateWithoutActions = Omit<
  IssueTemplateData,
  'actions' | 'addedBy' | 'id' | 'issueTypeConfigId'
> & {
  govmapGroups: string[];
};

export type IssueTemplateWithGovMapGroups = IssueTemplateEntity & {
  govmapGroups: Readonly<GovmapGroupsSchemaType> | null;
  issueTypeId: string;
  issueSubtypeId: string | null;
};
